var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var BenchmarkExport_1;
import { DateConverter, JSON, JsonConverter, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { benchmarkExportSchemaValidation } from '../validations.generated';
export const benchmarkExportSchema = {
    $id: 'urn:wisepipe-solution-domain:BenchmarkExport',
    type: 'object',
    properties: {
        companyName: { type: 'string', minLength: 1, maxLength: 100 },
        jobTitle: { type: 'string', minLength: 1, maxLength: 100 },
        country: { type: 'string', minLength: 1, maxLength: 100 },
        state: { type: 'string', maxLength: 100 },
        industry: { type: 'string', minLength: 1 },
        subIndustry: { type: 'string', minLength: 1 },
        growthGoal: { type: 'number', minimum: -10, maximum: 10 },
        growth: { type: 'number' },
        efficiency: { type: 'number' },
        attainment: { type: 'number' },
        enteredDate: { type: 'string', format: 'date-time' },
        email: { type: 'string', maxLength: 100 }
    },
    required: [
        'companyName',
        'jobTitle',
        'country',
        'industry',
        'subIndustry',
        'growth',
        'efficiency',
        'attainment',
        'enteredDate'
    ]
};
let BenchmarkExport = BenchmarkExport_1 = class BenchmarkExport {
    constructor(companyName, jobTitle, country, state, industry, subIndustry, growthGoal, growth, efficiency, attainment, enteredDate, email) {
        this.companyName = companyName;
        this.jobTitle = jobTitle;
        this.country = country;
        this.state = state;
        this.industry = industry;
        this.subIndustry = subIndustry;
        this.growthGoal = growthGoal;
        this.growth = growth;
        this.efficiency = efficiency;
        this.attainment = attainment;
        this.enteredDate = enteredDate;
        this.email = email;
        JSON.validate(this, BenchmarkExport_1);
    }
};
__decorate([
    JsonConverter(new DateConverter('date-time'))
], BenchmarkExport.prototype, "enteredDate", void 0);
BenchmarkExport = BenchmarkExport_1 = __decorate([
    JsonSchemaV2(benchmarkExportSchema, benchmarkExportSchemaValidation)
], BenchmarkExport);
export { BenchmarkExport };
//# sourceMappingURL=benchmarkExport.js.map